export default __webpack_public_path__ + "static/all-caps-do-0c7f5be0154a683d25c62b95181b7530.png";